<script>
import Logo from "@/components/Logo";
import Menu from "@/components/Menu";

export default {
  name: "App",

  components: {
    Logo,
    Menu,
  },
};
</script>

<template>
  <div id="app">
    <Logo />
    <Menu />
    <router-view />
  </div>
</template>

<style lang="scss">
html {
  font-size: 100%;
}

body {
  font-size: $font-size-base;
  line-height: $line-height-base;
  font-family: $font-family;
  font-weight: 500;
}
</style>
